import { Component, inject, input, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';

import { AppStore } from '../../store';

@Component({
  selector: 'app-currency-exchange-updated',
  templateUrl: './currency-exchange-updated.component.html',
  standalone: true,
  imports: [DatePipe],
})
export class CurrencyExchangeUpdatedComponent implements OnInit {
  readonly pageType = input<'detail' | 'summary' | 'success'>('detail');

  private _appStore = inject(AppStore);
  readonly currencyExchangeUpdatedDate =
    this._appStore.currencyExchangeUpdatedDate;

  constructor() {}

  ngOnInit(): void {}
}
